import styled from 'styled-components'
import Box from '@mui/material/Box'
import theme from '../../Theme'

export const StyledCustomTabPanelWrapper = styled(Box)`
  width: 100%;
  max-Width: ${theme.spacing(150)};
`
